<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">New Email Template</h1>
                <div class="Options">
                    <button :disabled="!CanSave" v-on:click.stop="Save()">Save</button>
                    <button v-on:click.stop="Close()">Close</button>
                </div>
            </div>
            <div class="modalBody" v-if="Saving">
                <p><loading-indicator /> Saving Email Template...</p>
            </div>
            <div class="modalBody" v-if="!Saving">
                <p><label>Template Name: <input v-model="TemplateName" /></label></p>
                <p><label>From Alias: <input v-model="FromAlias" /></label></p>
                <p><label>Email Subject: <input v-model="TemplateSubject" /></label></p>
                <div id="toolbar">
                    <!-- Add a bold button -->
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-link"></button>
                    <select class="ql-header">
                        <option></option>
                        <option value="1">Heading</option>
                    </select>
                    <label style="margin-top:10px;">Text Color: <input list="ftrccolors" type="color" @change="TextColorChanged($event)" /></label>
                    <label style="margin-top:10px;">Insert line: <input list="ftrccolors" type="color" @change="InsertLine($event)" /></label>
                    <datalist id="ftrccolors">
                        <option value="#1e228c" />
                        <option value="#f8c212" />
                        <option value="#9325b2" />
                        <option value="#3E5062" />
                    </datalist>
                    <button v-for="placeHolder in PlaceHolders" :key="placeHolder" style="color:black;width:120px;" @click="InsertPlaceholder(placeHolder)">{{'{'+placeHolder + '}'}}</button>

                </div>
                <div id="editor"></div>
                <quill-editor ref="quill" :options="QuillOptions" v-model="TemplateBody"></quill-editor>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .ql-picker {
        margin-top: 10px;
    }

    #toolbar label {
        margin-top: 10px;
        font-size: 14px;
        font-weight: normal;
        float: left;
        margin-right: 5px;
    }

        #toolbar label input[type=color] {
            width: 25px;
        }
</style>
<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import { quillEditor, Quill } from 'vue-quill-editor';
    import 'quill/dist/quill.core.css' // import styles
    import 'quill/dist/quill.snow.css';
    var BlockEmbed = Quill.import('blots/block/embed');
    class DividerBlot extends BlockEmbed {
        static create(value) {
            let node = super.create(value);
            if (value !== true && value !== false)
                //If the value is a string lets set the color here...
                node.setAttribute('style', "border: 1px solid " + value);
            return node;
        }
    }
    DividerBlot.blotName = 'divider';
    DividerBlot.tagName = 'hr';
    Quill.register(DividerBlot);

    export default {
        name: 'EmailTemplateCreator',
        components: {
            LoadingIndicator,
            quillEditor
        },
        props: ["TemplateType", "PlaceHolders"],
        created: function () {
        },
        data: function () {
            return {
                Saving: false,
                FromAlias: "",
                TemplateBody: "",
                TemplateName: "",
                TemplateSubject: ""
            }
        },
        methods: {
            TextColorChanged: function (event) {
                var quill = this.$refs.quill.quill;
                quill.format('color', event.srcElement.value);
            },
            InsertLine: function (event) {
                var quill = this.$refs.quill.quill;
                                var range = quill.getSelection(true);
                quill.insertText(range.index, '\n', Quill.sources.USER);
                quill.insertEmbed(range.index + 1, 'divider', event.srcElement.value, Quill.sources.USER);
                quill.setSelection(range.index + 2, Quill.sources.SILENT);
            },
            InsertPlaceholder: function (placeholder){
                this.$refs.quill.quill.insertText(this.$refs.quill.quill.selection.getRange()[0].index, "{{" + placeholder + "}}");
            },
            Save: function () {
                var thisControl = this;
                thisControl.Saving = true;
                var emailBody = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n<meta charset=\"utf-8\" /><title>"
                    + thisControl.TemplateSubject
                    + "</title>\r\n</head>\r\n<body style=\"font-family: Arial, Helvetica, sans-serif\">" + this.TemplateBody + "</body>\r\n</html>";
                var newTemplate = {

                    templateBody: emailBody,
                    templateSubject: thisControl.TemplateSubject,
                    type: this.TemplateType,
                    fromAlias: this.FromAlias,
                    templateName: this.TemplateName
                };
                fetch(
                    "/api/BulkRegistration/Templates",
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(newTemplate),
                    }
                ).then(
                    function () {
                        thisControl.$emit("template-added", null);
                    }
                ).catch(
                    function (error) {
                        thisControl.Saving = false;
                        alert("Error saving: " + error);
                    }
                )
            },
            Close: function () {
                this.$emit('cancel', null)
            }

        },
        watch: {

        },


        computed: {
            CanSave: function () {
                return !this.Saving
                    && this.TemplateName.trim().length > 0
                    && this.TemplateBody.trim().length > 0
                    && this.TemplateSubject.trim().length > 0
                    && this.FromAlias.trim().length > 0;
            },
            QuillOptions: {
                get: function () {
                    return {
                        theme: 'snow',
                        modules: {
                            /*toolbar: ['divider']*/
                            "toolbar": {
                                container: '#toolbar',

                            }
                        }
                    };
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->